// @ts-nocheck
import React, { useEffect, useState, useRef } from 'react';
import Sidebar from './Sidebar/Sidebar';
import Chat from './Chat/Chat';
import { Fade, Snackbar } from '@mui/material';
import PubSub from 'pubsub-js';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import SearchMessage from '../SearchMessage';
import ContactDetails from './ContactDetails';
import LoadingScreen from './LoadingScreen';
import Alert from '@mui/material/Alert';
import 'url-search-params-polyfill';
import mqtt from 'precompiled-mqtt';
import {
	CHAT_KEY_PREFIX,
	CONTACTS_TEMP_LIMIT,
	EVENT_TOPIC_BULK_MESSAGE_TASK,
	EVENT_TOPIC_BULK_MESSAGE_TASK_ELEMENT,
	EVENT_TOPIC_BULK_MESSAGE_TASK_STARTED,
	EVENT_TOPIC_CHAT_ASSIGNMENT,
	EVENT_TOPIC_CHAT_MESSAGE_STATUS_CHANGE,
	EVENT_TOPIC_CHAT_TAGGING,
	EVENT_TOPIC_CLEAR_TEXT_MESSAGE_INPUT,
	EVENT_TOPIC_CONTACT_DETAILS_VISIBILITY,
	EVENT_TOPIC_DISPLAY_ERROR,
	EVENT_TOPIC_MARKED_AS_RECEIVED,
	EVENT_TOPIC_NEW_CHAT_MESSAGES,
	EVENT_TOPIC_SEARCH_MESSAGES_VISIBILITY,
	EVENT_TOPIC_UNSUPPORTED_FILE,
	EVENT_TOPIC_ORDER_STATUS_UPDATE,
	RESTAURANT,
} from '@src/Constants';
import ChatMessageModel from '../../api/models/ChatMessageModel';
import PreviewMedia from './PreviewMedia';
import {
	getContactProvidersData,
	getToken,
	storeContactProvidersData,
} from '@src/helpers/StorageHelper';
import ChatAssignment from './ChatAssignment';
import ChatTags from './ChatTags';
import ChatTagsList from './ChatTagsList';
import DownloadUnsupportedFile from '../DownloadUnsupportedFile';
import moment from 'moment';
import { clearUserSession, generateCancelToken } from '@src/helpers/ApiHelper';
import BulkMessageTaskElementModel from '../../api/models/BulkMessageTaskElementModel';
import BulkMessageTaskModel from '../../api/models/BulkMessageTaskModel';
import { getWebSocketURL } from '@src/helpers/URLHelper';
import { isIPad13, isMobileOnly } from 'react-device-detect';
import UploadMediaIndicator from './Sidebar/UploadMediaIndicator';
import { useTranslation } from 'react-i18next';
import { AppConfig } from '@src/contexts/AppConfig';
import { ApplicationContext } from '@src/contexts/ApplicationContext';
import SendBulkVoiceMessageDialog from '../SendBulkVoiceMessageDialog';
import BulkSendTemplateViaCSV from '../BulkSendTemplateViaCSV/BulkSendTemplateViaCSV';
import { setTemplates } from '@src/store/reducers/templatesReducer';
import BulkSendTemplateDialog from '../BulkSendTemplateDialog';
import { setCurrentUser, setPermissions } from '@src/store/reducers/currentUserReducer';
import CurrentUserResponse from '../../api/responses/CurrentUserResponse';
import TemplatesResponse from '../../api/responses/TemplatesResponse';
import UploadRecipientsCSV from '../UploadRecipientsCSV';
import { findTagByName } from '@src/helpers/TagHelper';
import { setTags } from '@src/store/reducers/tagsReducer';
import ContactsResponse from '@src/api/responses/ContactsResponse';
import { prepareContactProvidersData } from '@src/helpers/ContactProvidersHelper';
import { useAppDispatch, useAppSelector } from '@src/store/hooks';
import UsersResponse from '@src/api/responses/UsersResponse';
import { setUsers } from '@src/store/reducers/usersReducer';
import { setSavedResponses } from '@src/store/reducers/savedResponsesReducer';
import SavedResponsesResponse from '@src/api/responses/SavedResponsesResponse';
import { setChatAssignment, setChatTagging } from '@src/store/reducers/chatsReducer';
import BulkSendPayload from '@src/interfaces/BulkSendPayload';
import { getAllCustomFields, getOrganizationGetChat } from '@src/api/SudoApiService';
import ManageTags from './ManageTags';
import CustomNavigation from '../CustomNavigation/CustomNavigation';
import { getBaseRoute, generateUniqueID, validPhoneNumber } from '@src/helpers/Helpers';
import Catalogs from '@src/pages/Catalogs';
import Orders from '../../pages/Orders/Orders';
import OrderBook from '../OrderBook/OrderBook';
import Dashboard from '../Dashboard/Dashboard';
import { IsMobileWidth } from '../MediaQueryUtils/index.ts';
import Products from '@src/pages/Products';
import EditOrder from '@src/pages/Orders/editOrder';
import OrderbookProducts from '@src/pages/Orders/orderbookProducts';
import MarketPlace from '@src/pages/MarketPlace';
import ProductDetails from '@src/pages/MarketPlace/Components/Products/ProductDetails';
import Settings from '@src/pages/Settings';
import { ALL_PERMISSION_MAP } from '@src/helpers/Permission';
import usePermission from '@src/hooks/usePermission';
import InsightsAi from '@src/pages/InsightsAI';
import OrderManagement from '@src/pages/Orders';
import PreviewImage from '../PreviewMedia/PreviewImage';
import Finance from '@src/pages/Finance';
import MarketPlaceSoon from '@src/pages/MarketPlace/MarketPlaceSoon';
import StorefrontPreview from '@src/pages/MarketPlace/PublicPreview/StorefrontPreview';
import Notifications from '../Notifications/Notifications';
import { NotificationIcon } from '../Icons';
import PullToRefresh from 'react-simple-pull-to-refresh';
import { setPullToRefresh } from '@src/store/reducers/UIReducer';
import CustomBottomNavigation from '../CustomNavigation/CustomBottomNavigation';
import RewardsDashboard from '@src/pages/Rewards/RewardsDashboard';
import RewardsSettings from '@src/pages/Rewards/RewardsSettings';
import CustomerList from '@src/pages/Customers/CustomerList';
import CreditLimit from '@src/pages/Customers/CreditLimit';
import CustomerWallet from '@src/pages/Rewards/CustomerWallet';
import ProfileCheckModal from './ProfileCheckModal';

function useQuery() {
	return new URLSearchParams(useLocation().search);
}

function Main() {
	const { apiService } = React.useContext(ApplicationContext);
	const config = React.useContext(AppConfig);

	let mqttFlag = false;
	const chats = useAppSelector((state) => state.chats.value);
	const tags = useAppSelector((state) => state.tags.value);
	const previewMediaObject = useAppSelector((state) => state.previewMediaObject.value);
	const currentUser: any = useAppSelector((state) => state?.currentUser?.value);
	const isPreviewImages: any = useAppSelector((state) => state?.UI?.isPreviewImages);
	const pullToRefresh: any = useAppSelector((state) => state?.UI?.pullToRefresh);
	const updateFound: any = useAppSelector((state) => state?.UI?.updateFound);

	const dispatch = useAppDispatch();

	const { t } = useTranslation();

	const { waId, id, orderId, productId, supplierId } = useParams();

	//Permission
	const checkPermission = usePermission();
	const editOrderPermission = checkPermission(ALL_PERMISSION_MAP?.GENERAL?.ORDER?.UPDATE, waId);
	const canReceiveMessages = checkPermission(ALL_PERMISSION_MAP?.GENERAL?.MESSAGE?.RECEIVE, waId);
	const [restaurantApprovalNotification, setRestaurantApprovalNotification] = useState(false);

	const [progress, _setProgress] = useState(0);
	const [loadingNow, setLoadingNow] = useState('');
	const [isInitialResourceFailed, setInitialResourceFailed] = useState(false);

	const [checked, setChecked] = useState(false);
	const [isBlurred, setBlurred] = useState(false);

	const [isSendingPendingMessages, setSendingPendingMessages] = useState(false);
	const [pendingMessages, setPendingMessages] = useState([]);
	const [hasFailedMessages, setHasFailedMessages] = useState(false);
	const [lastSendAttemptAt, setLastSendAttemptAt] = useState();

	const [isUploadingMedia, setUploadingMedia] = useState(false);

	const [newMessages, setNewMessages] = useState({});

	const [isTemplatesFailed, setTemplatesFailed] = useState(false);

	const [isLoadingTemplates, setLoadingTemplates] = useState(true);
	const [templatesReady, setTemplatesReady] = useState(false);

	const [isSuccessVisible, setSuccessVisible] = useState(false);
	const [successMessage, setSuccessMessage] = useState('');
	const [isErrorVisible, setErrorVisible] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');
	const [messageCount, setMessageCount] = useState(false);
	const [newMsgReceived, setNewMsgReceived] = useState(false);

	const [isSearchMessagesVisible, setSearchMessagesVisible] = useState(false);
	const [isContactDetailsVisible, setContactDetailsVisible] = useState(false);
	const [isChatAssignmentVisible, setChatAssignmentVisible] = useState(false);
	const [isChatTagsVisible, setChatTagsVisible] = useState(false);
	const [isChatTagsListVisible, setChatTagsListVisible] = useState(false);
	const [isDownloadUnsupportedFileVisible, setDownloadUnsupportedFileVisible] = useState(false);
	const [restaurantId, setRestaurantId] = useState('');
	const [permissionLoader, setPermissionLoader] = useState(true);

	const [searchMessagesInitialKeyword, setSearchMessagesInitialKeyword] = useState('');

	const [unsupportedFile, setUnsupportedFile] = useState();

	const [chosenContact, setChosenContact] = useState();

	const [contactProvidersData, setContactProvidersData] = useState(getContactProvidersData());

	const [isSelectionModeEnabled, setSelectionModeEnabled] = useState(false);
	const [selectedChats, setSelectedChats] = useState([]);
	const [selectedTags, setSelectedTags] = useState([]);
	const [bulkSendPayload, setBulkSendPayload] = useState<BulkSendPayload>();

	const [isBulkSendTemplateDialogVisible, setBulkSendTemplateDialogVisible] = useState(false);

	const [
		isBulkSendTemplateWithCallbackDialogVisible,
		setBulkSendTemplateWithCallbackDialogVisible,
	] = useState(false);

	const [isUploadRecipientsCSVVisible, setUploadRecipientsCSVVisible] = useState(false);

	const [isBulkSendTemplateViaCSVVisible, setBulkSendTemplateViaCSVVisible] = useState(false);

	const [isSendBulkVoiceMessageDialogVisible, setSendBulkVoiceMessageDialogVisible] =
		useState(false);

	const [organizationData, setOrganizationData] = useState();
	const [contactDetails, setContactDetails] = useState([]);
	const [showTagsManagement, setShowTagsManagement] = useState(false);
	const [open, setOpen] = useState<boolean>(true);
	const [mqttConnected, setMqttConnected] = useState(false);
	const [isOffline, setIsOffline] = useState(false);
	const [oneSignalUserId, setOneSignalUserId] = useState(null);

	const [notificationHistory, setNotificationHistory] = useState({});
	const [chatId, setChatId] = useState('');

	const isRestaurant = currentUser?.type?.toLowerCase() === RESTAURANT;

	const [orderMetadata, setOrderMetadata] = useState(null);

	//Order States
	const [isOrderBook, setOrderBook] = useState(false);
	const [feeadbackField, setFieldBackField] = useState(null);

	const [client, setClient] = useState(null);
	let mqttString;
	const [internetStatus, setInternetStatus] = useState(null);
	const cancelTokenSourceRef = useRef();
	const navigate = useNavigate();
	const location = useLocation();
	const isMobileWidth = IsMobileWidth();
	const { toggleMenu } = useAppSelector((state) => state.UI);
	const query = useQuery();
	const confirmationMessage = t(
		'There are unsent messages in the chat. If you continue, they will be deleted. Are you sure you want to continue?'
	);

	const checkIsChatOnly = () => {
		return query.get('chatonly') === '1';
	};

	const [isChatOnly] = useState(checkIsChatOnly());

	const setProgress = (value) => {
		_setProgress((prevState) => {
			return value > prevState ? value : prevState;
		});
	};

	const displaySuccess = (message) => {
		setSuccessMessage(message);
		setSuccessVisible(true);
	};

	const displayError = (error) => {
		if (!axios.isCancel(error)) {
			setErrorMessage(error.response?.data?.reason ?? 'An error has occurred.');
			setErrorVisible(true);
		}
	};

	const displayCustomError = (error: AxiosError) => {
		const msg = error?.response?.data?.message || 'Something went wrong!';
		setErrorMessage(msg);
		setErrorVisible(true);
	};

	const handleSuccessClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}

		setSuccessVisible(false);
	};

	const handleErrorClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}

		setErrorVisible(false);
	};

	function getOrderMetadata() {
		apiService.getOrderMetadata(
			(response) => {
				console.log(response);
				setOrderMetadata(response.data.data);
			},
			(error) => {
				console.log(error);
			}
		);
	}

	const finishBulkSendMessage = (payload) => {
		const requestPayload = {};
		const messagePayload = { ...bulkSendPayload };
		const recipients = selectedChats;
		const tags = selectedTags;

		const preparedRecipients = [];
		recipients.forEach((recipient) => {
			preparedRecipients.push({ recipient: recipient });
		});

		const preparedTags = [];
		tags.forEach((tag) => {
			preparedTags.push({ tag_id: tag });
		});

		requestPayload.recipients = payload ? payload.recipients : preparedRecipients;
		requestPayload.tags = preparedTags;
		requestPayload.payload = payload
			? { template: payload.template, type: payload.type }
			: messagePayload;

		apiService.bulkSendCallV2(requestPayload, (response) => {
			// Disable selection mode
			setSelectionModeEnabled(false);

			// Clear selections
			setSelectedChats([]);
			setSelectedTags([]);

			// Clear input if text message
			if (messagePayload.type === 'text') {
				PubSub.publish(EVENT_TOPIC_CLEAR_TEXT_MESSAGE_INPUT);
			}

			const preparedBulkMessageTask = new BulkMessageTaskModel(response.data.data);
			PubSub.publish(EVENT_TOPIC_BULK_MESSAGE_TASK_STARTED, preparedBulkMessageTask);
		});
	};

	const goToChatByWaId = (_waId) => {
		navigate(`/${getBaseRoute(currentUser?.type)}/${id}/chat/${_waId}`);
	};

	const displayNotification = (title, body, chatWaId) => {
		if (isChatOnly) return;

		// Android web app interface
		if (window.AndroidWebInterface) {
			window.AndroidWebInterface.displayNotification(title, body, chatWaId);
		}

		function displayNtf() {
			const timeString = moment().seconds(0).milliseconds(0).toISOString();

			setNotificationHistory((prevState) => {
				// Notification limit per minute
				if (
					(prevState[timeString]?.length ?? 0) >= (config.APP_NOTIFICATIONS_LIMIT_PER_MINUTE ?? 8)
				) {
					console.info('Cancelled a notification.');
					return prevState;
				}

				// TODO: Use ServiceWorkerRegistration instead to fix notifications on Android
				try {
					// eslint-disable-next-line no-unused-vars
					const notification = new Notification(title, {
						body: body,
						icon: process.env.REACT_APP_LOGO_URL ?? '/ylPartsLogo.png',
						tag: chatWaId + timeString,
					});

					notification.onclick = function (event) {
						window.focus();

						if (waId) {
							goToChatByWaId(chatWaId);
						}
					};
				} catch (e) {
					console.log(e);
				}

				if (!prevState.hasOwnProperty(timeString)) {
					prevState[timeString] = [];
				}

				prevState[timeString].push(chatWaId);

				// Clear older elements to prevent growing
				const nextState = {};
				nextState[timeString] = prevState[timeString];

				return { ...nextState };
			});
		}

		if (!window.Notification) {
			console.log('Browser does not support notifications.');
		} else {
			// Check if permission is already granted
			if (Notification.permission === 'granted') {
				displayNtf();
			} else {
				// Request permission from user
				// TODO: Safari doesn't return a promise, fix it
				Notification.requestPermission()
					?.then(function (p) {
						if (p === 'granted') {
							displayNtf();
						} else {
							console.log('User blocked notifications.');
						}
					})
					.catch(function (err) {
						console.error(err);
					});
			}
		}
	};

	const onSearchMessagesVisibilityEvent = function (msg, data) {
		setSearchMessagesVisible(data);

		// Hide other sections
		if (data === true) {
			setContactDetailsVisible(false);
		}
	};

	const onContactDetailsVisibilityEvent = function (msg, data) {
		setContactDetailsVisible(data);

		// Hide other sections
		if (data === true) {
			setSearchMessagesVisible(false);
		}
	};

	const onDisplayError = function (msg, data) {
		displayCustomError(data);
	};

	const getNotifications = () => {
		apiService.getApprovalRequestList(
			(res: AxiosResponse) => {
				const data = res?.data?.data;
				if (data?.length) {
					setRestaurantApprovalNotification(true);
				}
			},
			(err: AxiosError) => {
				displayCustomError(err);
			}
		);
	};

	useEffect(() => {
		if (!currentUser?.type && location?.pathname?.startsWith('/marketplace/storeFront')) {
			setProgress(100);
			return;
		}
		try {
			// Display custom errors in any component
			window.displayCustomError = displayCustomError;

			// Display success in any component
			window.displaySuccess = displaySuccess;

			// Display Axios errors in any component
			window.displayError = displayError;

			// We assign this method to window, to be able to call it from outside (eg: mobile app)
			window.goToChatByWaId = goToChatByWaId;

			if (!getToken()) {
				clearUserSession('notLoggedIn', location, navigate);
			}

			// Retrieve current user, this will trigger other requests
			retrieveCurrentUser();

			const onUnsupportedFileEvent = function (msg, data) {
				setUnsupportedFile(data);
				setDownloadUnsupportedFileVisible(true);
			};

			// EventBus
			const searchMessagesVisibilityEventToken = PubSub.subscribe(
				EVENT_TOPIC_SEARCH_MESSAGES_VISIBILITY,
				onSearchMessagesVisibilityEvent
			);
			const contactDetailsVisibilityEventToken = PubSub.subscribe(
				EVENT_TOPIC_CONTACT_DETAILS_VISIBILITY,
				onContactDetailsVisibilityEvent
			);
			const displayErrorEventToken = PubSub.subscribe(EVENT_TOPIC_DISPLAY_ERROR, onDisplayError);
			const unsupportedFileEventToken = PubSub.subscribe(
				EVENT_TOPIC_UNSUPPORTED_FILE,
				onUnsupportedFileEvent
			);

			return () => {
				PubSub.unsubscribe(searchMessagesVisibilityEventToken);
				PubSub.unsubscribe(contactDetailsVisibilityEventToken);
				PubSub.unsubscribe(displayErrorEventToken);
				PubSub.unsubscribe(unsupportedFileEventToken);
			};
		} catch (err) {
			console.log(err);
		}
	}, [pullToRefresh]);

	useEffect(() => {
		if (isBlockApiCalls()) {
			return;
		}
		let client;
		let userId = generateUniqueID();
		const MQTT_OPTIONS = {
			keepalive: 60,
			reconnectPeriod: 5000,
		};

		const checkMqttTopics = (mqttString, topic) => {
			if (mqttString !== topic) {
				return;
			}
		};

		const unsubscribeMqttClient = (client) => {
			client?.unsubscribe(userId, function (err) {
				if (err) {
					console.error(err);
				}
				console.log('MQTT unsubscribed');
				client?.end();
			});
		};

		cancelTokenSourceRef.current = generateCancelToken();
		function getPresignedUrl() {
			return new Promise((resolve, reject) => {
				apiService.getMqttPresignedUrl(
					cancelTokenSourceRef.current.token,
					(response) => {
						return resolve(response.data.data);
					},
					(err) => {
						console.log(err);
						reject(err);
					},
					id
				);
			});
		}

		const connectMQTT = async () => {
			const mqttConnectionData = await getPresignedUrl();
			console.log(mqttConnectionData);

			const presignedUrl = mqttConnectionData.presignedUrl.url;
			client = mqtt.connect(presignedUrl);
			setClient(client);
			// console.log('client');
			// console.log(client);

			const setupEventListeners = (client) => {
				client.on('connect', function () {
					console.log('MQTT connected');
					client.subscribe(mqttConnectionData?.topic, function (err) {
						if (err) {
							console.log(err);
						}
						mqttString = mqttConnectionData?.topic;
						console.log('MQTT subscribed');
					});

					client.on('message', function (topic, message) {
						// console.log('Ping Event');
						checkMqttTopics(mqttString, topic);
						try {
							const data = JSON.parse(message);
							if (data.type === 'waba_webhook') {
								console.log(`-------------------- New Message ${new Date()}`);
								console.log(JSON.parse(message.toString()));
								const newMsgRestaurantId = JSON.parse(message.toString())?.waba_payload
									?.outgoing_messages?.[0]?.contact?.waba_payload?.profile?.restaurantId;
								setRestaurantId(newMsgRestaurantId);
								setNewMsgReceived(true);

								const wabaPayload = data.waba_payload;

								// Incoming messages
								const incomingMessages = wabaPayload?.incoming_messages;
								if (incomingMessages) {
									const preparedMessages = {};

									incomingMessages.forEach((message) => {
										const messageObj = new ChatMessageModel(message);
										preparedMessages[messageObj.id] = messageObj;
									});

									PubSub.publish(EVENT_TOPIC_NEW_CHAT_MESSAGES, preparedMessages);
								}

								// Outgoing messages
								const outgoingMessages = wabaPayload?.outgoing_messages;

								if (outgoingMessages) {
									const preparedMessages = {};
									let msgId = '';

									outgoingMessages.forEach((message) => {
										const messageObj = new ChatMessageModel(message);
										msgId = messageObj.id;
										preparedMessages[messageObj.id] = messageObj;
									});

									PubSub.publish(EVENT_TOPIC_NEW_CHAT_MESSAGES, preparedMessages);
								}

								// Statuses
								const statuses = wabaPayload?.statuses;

								if (statuses) {
									const preparedStatuses = {};
									statuses.forEach((statusObj) => {
										if (!preparedStatuses.hasOwnProperty(statusObj.id)) {
											preparedStatuses[statusObj.id] = {};
										}

										// Inject getchat id to avoid duplicated messages
										preparedStatuses[statusObj.id].getchatId = statusObj.getchat_id;

										if (statusObj.status === ChatMessageModel.STATUS_SENT) {
											preparedStatuses[statusObj.id].sentTimestamp = statusObj.timestamp;
										}

										if (statusObj.status === ChatMessageModel.STATUS_DELIVERED) {
											preparedStatuses[statusObj.id].deliveredTimestamp = statusObj.timestamp;
										}

										if (statusObj.status === ChatMessageModel.STATUS_READ) {
											preparedStatuses[statusObj.id].readTimestamp = statusObj.timestamp;
										}

										// Handling errors
										if (statusObj.errors) {
											preparedStatuses[statusObj.id].errors = statusObj.errors;
										}
									});

									PubSub.publish(EVENT_TOPIC_CHAT_MESSAGE_STATUS_CHANGE, preparedStatuses);
								}
							} else if (data.type === 'message_updated') {
								console.log('Order Update web hook');
								PubSub.publish(EVENT_TOPIC_ORDER_STATUS_UPDATE, data);
							}
						} catch (error) {
							console.error(error);
							// Do not force Sentry if exceptions can't be handled without a user feedback dialog
							//Sentry.captureException(error);
						}
					});

					client.subscribe(userId, function (err) {
						if (err) {
							console.log(err);
						}
						console.log('MQTT subscribed');
					});
				});

				// client.on('error', async (err) => {
				// 	console.error('Connection error: ', err);
				// 	client.end();
				// 	setClient(null);
				// });

				// client.on('reconnect', () => {
				// 	console.log('Reconnected');
				// });

				client.on('close', async () => {
					console.log('MQTT closed');
					client?.end();
					setClient(null);
				});
			};

			setupEventListeners(client);
		};

		const connect = async () => {
			try {
				await connectMQTT();
			} catch (error) {
				console.error(error);
			}
		};

		const id = setInterval(() => {
			if (client) {
				client.publish(userId, JSON.stringify({ event: 'ping' }));
			}
			setClient((c) => {
				if (!c?.connected && navigator?.onLine) {
					// console.log('c1');
					// console.log(c);
					// Unsubscribe from topics and close the MQTT connection
					unsubscribeMqttClient(client);
					connect();
				}
				return c;
			});
		}, 3000);
		return () => {
			clearInterval(id);
			if (client) {
				// Unsubscribe from topics and close the MQTT connection
				unsubscribeMqttClient(client);
			}
		};
	}, []);

	useEffect(() => {
		// Window close event
		window.addEventListener('beforeunload', alertUser);
		return () => {
			window.removeEventListener('beforeunload', alertUser);
		};
	}, [hasFailedMessages]);

	const alertUser = (e) => {
		if (hasFailedMessages) {
			if (!window.confirm(confirmationMessage)) {
				e.preventDefault();
				e.returnValue = '';
			}
		}
	};

	useEffect(() => {
		let tryLoadingTemplatesTimeoutId;
		if (isTemplatesFailed) {
			let timeout = 10000;
			const delay = () => {
				timeout += 1000;
				return timeout;
			};

			let retryTask = () => {
				tryLoadingTemplatesTimeoutId = setTimeout(() => {
					listTemplates(true);
					retryTask();
				}, delay());
			};

			retryTask();
		}

		return () => {
			clearTimeout(tryLoadingTemplatesTimeoutId);
		};
	}, [isTemplatesFailed]);

	useEffect(() => {
		function onBlur(event) {
			setBlurred(true);
		}

		function onFocus(event) {
			setBlurred(false);
		}

		window.addEventListener('blur', onBlur);
		window.addEventListener('focus', onFocus);

		return () => {
			window.removeEventListener('blur', onBlur);
			window.removeEventListener('focus', onFocus);
		};
	}, [isBlurred]);

	useEffect(() => {
		setChecked(true);

		return () => {
			// Hide search messages container
			setSearchMessagesVisible(false);

			// Hide contact details
			setContactDetailsVisible(false);

			// Hide chat assignment
			setChatAssignmentVisible(false);
		};
	}, [waId]);

	const generateChatId = (id, waId) => {
		if (currentUser?.type?.toLowerCase() !== RESTAURANT) {
			return CHAT_KEY_PREFIX + id + waId;
		}
		return CHAT_KEY_PREFIX + waId;
	};

	useEffect(() => {
		const onMarkedAsReceived = function (msg, data) {
			// console.log('waId' + data);
			const relatedWaId = data;
			let msgCount; //to subtract count of unread msg
			setNewMessages((prevState) => {
				const nextState = prevState;
				// console.log(nextState);
				msgCount = nextState[CHAT_KEY_PREFIX + relatedWaId]?.newMessages;
				delete nextState[CHAT_KEY_PREFIX + relatedWaId];

				return { ...nextState };
			});
			setMessageCount(messageCount - msgCount);
		};

		const markedAsReceivedEventToken = PubSub.subscribe(
			EVENT_TOPIC_MARKED_AS_RECEIVED,
			onMarkedAsReceived
		);

		return () => {
			PubSub.unsubscribe(markedAsReceivedEventToken);
		};
	}, [newMessages]);

	useEffect(() => {
		storeContactProvidersData(contactProvidersData);
	}, [contactProvidersData]);

	// Clear selected chats and tags when bulk send payload changes
	useEffect(() => {
		if (bulkSendPayload) {
			setSelectedChats([]);
			setSelectedTags([]);
		}
	}, [bulkSendPayload]);

	//Get Unread Message Count
	useEffect(() => {
		if (isBlockApiCalls()) {
			return;
		}
		if (progress === 100) {
			apiService?.getUnreadMessageCount(
				(response: AxiosResponse) => {
					const { unreadCount } = response?.data?.data;
					setMessageCount(unreadCount);
					setNewMsgReceived(false);
				},
				(error: AxiosError) => {},
				id
			);
		}
	}, [waId, id, newMsgReceived, progress, pullToRefresh]);

	// ** 2 **
	const listUsers = async () => {
		setLoadingNow('Users');

		// try {
		// 	await apiService.listUsersCallV2(5000, (response) => {
		// 		const usersResponse = new UsersResponse(response.data.data);

		// 		// Store
		// 		dispatch(setUsers(usersResponse.users));

		// 		setProgress(20);
		// 	});
		// } catch (error) {
		// 	console.error('Error in listUsers', error);
		// 	setInitialResourceFailed(true);
		// } finally {
		// 	// Trigger next request
		// 	listContacts();
		// }

		//temp
		const usersResponse = new UsersResponse({
			count: 0,
			next: null,
			previous: null,
			results: [],
		});

		// Store
		dispatch(setUsers(usersResponse.users));

		setProgress(20);
		listContacts();
	};

	const getMyPermissions = () => {
		apiService.getMyPermissions(
			(response: AxiosResponse) => {
				dispatch(setPermissions(response?.data?.data));
				setPermissionLoader(false);
			},
			(error: AxiosError) => {
				displayError('Something went wrong!');
				setPermissionLoader(false);
			}
		);
	};

	// ** 1 **
	const retrieveCurrentUser = async () => {
		setLoadingNow('Current User');

		try {
			await apiService.retrieveCurrentUserCallV2(
				(response) => {
					const currentUserResponse = new CurrentUserResponse(response?.data?.data);
					//console.log(currentUserResponse);
					dispatch(setCurrentUser(currentUserResponse?.currentUser));

					//const role = currentUserResponse.currentUser.role;

					// Only admins and users can access
					// if (role !== 'admin' && role !== 'user') {
					// 	clearUserSession('incorrectRole', location, navigate);
					// }

					setProgress(10);
				},
				(error) => {},
				navigate,
				id
			);
		} catch (error) {
			console.error('Error retrieving current user', error);
			setInitialResourceFailed(true);
		} finally {
			// Trigger next request
			listUsers();
		}
	};

	// ** 5 **
	const listTemplates = async (isRetry) => {
		setLoadingNow('Templates');

		const completeCallback = () => {
			setLoadingTemplates(false);
			setTemplatesReady(true);

			setProgress(70);

			// Trigger next request
			listTags();
		};

		// await apiService.listTemplatesCallV2(
		// 	undefined,
		// 	(response) => {
		// 		const templatesResponse = new TemplatesResponse(response.data);

		// 		dispatch(setTemplates(templatesResponse.templates));

		// 		if (!isRetry) {
		// 			completeCallback();
		// 		}

		// 		setTemplatesFailed(false);
		// 	},
		// 	(error) => {
		// 		if (!isRetry) {
		// 			if (error.response) {
		// 				const status = error.response.status;
		// 				// Status code >= 500 means template management is not available
		// 				if (status >= 500) {
		// 					const reason = error.response.data?.data?.reason;
		// 					displayCustomError(reason);
		// 					completeCallback();

		// 					// To trigger retrying periodically
		// 					setTemplatesFailed(true);
		// 				} else {
		// 					//window.displayError(error);
		// 				}
		// 			} else {
		// 				// auto skip if no response
		// 				completeCallback();
		// 				//window.displayError(error);
		// 			}

		// 			setInitialResourceFailed(true);
		// 		} else {
		// 			console.error(error);
		// 		}
		// 	}
		//);

		//temp
		const templatesResponse = new TemplatesResponse({
			message: 'Successfully get all templates',
			results: [],
			success: true,
			count: 0,
		});

		dispatch(setTemplates(templatesResponse.templates));

		if (!isRetry) {
			completeCallback();
		}

		setTemplatesFailed(false);
	};

	// ** 4 **
	const listSavedResponses = async () => {
		// try {
		// 	await apiService.listSavedResponsesCallV2((response) => {
		// 		const savedResponsesResponse = new SavedResponsesResponse(response.data);
		// 		console.log(savedResponsesResponse);
		// 		// Store
		// 		dispatch(setSavedResponses(savedResponsesResponse.savedResponses));
		// 		setProgress(50);
		// 	});
		// } catch (error) {
		// 	console.error('Error in listSavedResponses', error);
		// 	setInitialResourceFailed(true);
		// } finally {
		// 	// Trigger next request
		// 	listTemplates(false);
		// }

		//temp
		const savedResponsesResponse = new SavedResponsesResponse({
			message: 'Successfully fetched saved response.',
			next: null,
			previous: null,
			count: 1,
			results: [],
		});
		dispatch(setSavedResponses(savedResponsesResponse.savedResponses));
		setProgress(50);
		listTemplates(false);
	};

	const createSavedResponse = (text) => {
		apiService.createSavedResponseCallV2(text, (response) => {
			// Display a success message
			displaySuccess('Saved as response successfully!');

			// Reload saved responses
			listSavedResponses();
		});
	};

	const resolveContact = (personWaId) => {
		if (contactProvidersData?.[personWaId] !== undefined) {
			// Already retrieved
			return;
		}

		if (!personWaId) {
			console.warn('Resolve contact: wa_id is undefined!');
			return;
		}

		if (!validPhoneNumber(personWaId)) {
			return;
		}

		console.log('Resolving contact: ' + personWaId);

		apiService.resolveContactCallV2(
			personWaId,
			(response) => {
				setContactProvidersData((prevState) => {
					prevState[personWaId] = response.data.data.contact_provider_results;
					return { ...prevState };
				});
			},
			(error) => {
				if (error?.response?.status === 404) {
					console.log('Contact is not found.');
				} else {
					//window.displayError(error);
				}
			},
			id
		);
	};

	// ** 3 **
	const listContacts = async () => {
		setLoadingNow('Contacts');

		// Check if it needs to be loaded
		if (Object.keys(contactProvidersData).length !== 0) {
			setProgress(35);
			setLoadingNow('Saved Responses');
			listSavedResponses();
			return;
		}

		let mergedResults = [];
		const completeCallback = () => {
			const preparedData = prepareContactProvidersData(mergedResults);
			setContactProvidersData(preparedData);

			setProgress(35);
			setLoadingNow('Saved Responses');

			// Trigger next request
			listSavedResponses();
		};

		const makeRequest = async (pages) => {
			await apiService.listContactsCallV2(
				undefined,
				CONTACTS_TEMP_LIMIT,
				pages,
				undefined,
				(response) => {
					const contactsResponse = new ContactsResponse({ results: [] });
					mergedResults = mergedResults.concat(contactsResponse.results);
					if (contactsResponse.next && mergedResults.length < contactsResponse.count) {
						const nextURL = new URL(contactsResponse.next);
						const pages = nextURL.searchParams.get('pages');
						makeRequest(pages);
					} else {
						completeCallback();
					}
				},
				(error) => {
					console.error('Error in listContacts', error);
					setInitialResourceFailed(true);
				}
			);
		};

		await makeRequest();
	};

	// ** 6 **
	const listTags = async () => {
		// try {
		// 	await apiService.listTagsCallV2((response) => {
		// 		dispatch(setTags(response?.data?.data?.results));
		// 	});
		// } catch (error) {
		// 	console.error('Error in listTags', error);
		// }

		//temp
		dispatch(setTags([]));
	};

	const isBlockApiCalls = () => {
		if (!currentUser?.type && location?.pathname?.startsWith('/marketplace/storeFront')) {
			return true;
		}
		return false;
	};

	useEffect(() => {
		if (isBlockApiCalls()) {
			return;
		}
		if (progress === 100) {
			getMyPermissions();

			//getNotifications
			if (!isRestaurant && !location.pathname?.includes('settings/tallyApproval')) {
				getNotifications();
			}
		}
	}, [progress, pullToRefresh]);

	useEffect(() => {
		if (!navigator?.onLine) {
			setIsOffline(!navigator?.onLine);
		}

		const handleOnlineStatusChange = () => {
			setIsOffline(!navigator?.onLine);
		};

		window.addEventListener('online', handleOnlineStatusChange);
		window.addEventListener('offline', handleOnlineStatusChange);

		return () => {
			window.removeEventListener('online', handleOnlineStatusChange);
			window.removeEventListener('offline', handleOnlineStatusChange);
		};
	}, []);

	useEffect(() => {
		getOrderMetadata();
	}, []);

	const handleClose = () => {
		setIsOffline(false);
	};

	const showMenu = (path: string) => {
		if (path?.includes('/marketplace/storeFront') && !isRestaurant) {
			return null;
		}
		return !isMobileWidth ? (
			<CustomNavigation
				open={open}
				setOpen={setOpen}
				setOrderBook={setOrderBook}
				messageCount={canReceiveMessages ? messageCount : 0}
			/>
		) : isMobileWidth && toggleMenu ? (
			<CustomNavigation
				open={open}
				setOpen={setOpen}
				setOrderBook={setOrderBook}
				messageCount={messageCount}
			/>
		) : null;
	};

	const mainChatComponent = () => {
		return (
			<>
				{templatesReady && (!location?.pathname?.includes('chat') || !isMobileWidth) ? (
					<Sidebar
						pendingMessages={pendingMessages}
						setPendingMessages={setPendingMessages}
						isSendingPendingMessages={isSendingPendingMessages}
						hasFailedMessages={hasFailedMessages}
						lastSendAttemptAt={lastSendAttemptAt}
						isUploadingMedia={isUploadingMedia}
						newMessages={newMessages}
						setNewMessages={setNewMessages}
						setProgress={setProgress}
						displayNotification={displayNotification}
						isBlurred={isBlurred}
						contactProvidersData={contactProvidersData}
						retrieveContactData={resolveContact}
						isChatOnly={isChatOnly}
						setChatTagsListVisible={setChatTagsListVisible}
						isSelectionModeEnabled={isSelectionModeEnabled}
						setSelectionModeEnabled={setSelectionModeEnabled}
						bulkSendPayload={bulkSendPayload}
						selectedChats={selectedChats}
						setSelectedChats={setSelectedChats}
						selectedTags={selectedTags}
						setSelectedTags={setSelectedTags}
						finishBulkSendMessage={finishBulkSendMessage}
						setLoadingNow={setLoadingNow}
						setUploadRecipientsCSVVisible={setUploadRecipientsCSVVisible}
						setBulkSendTemplateDialogVisible={setBulkSendTemplateDialogVisible}
						setBulkSendTemplateWithCallbackDialogVisible={
							setBulkSendTemplateWithCallbackDialogVisible
						}
						setBulkSendTemplateViaCSVVisible={setBulkSendTemplateViaCSVVisible}
						setInitialResourceFailed={setInitialResourceFailed}
						setSendBulkVoiceMessageDialogVisible={setSendBulkVoiceMessageDialogVisible}
						chatId={chatId}
						setChatId={setChatId}
						setShowTagsManagement={setShowTagsManagement}
						restaurantId={restaurantId}
						setFieldBackField={setFieldBackField}
						permissionLoader={permissionLoader}
					/>
				) : null}
				{templatesReady && (
					<Chat
						pendingMessages={pendingMessages}
						setPendingMessages={setPendingMessages}
						isSendingPendingMessages={isSendingPendingMessages}
						setSendingPendingMessages={setSendingPendingMessages}
						hasFailedMessages={hasFailedMessages}
						setHasFailedMessages={setHasFailedMessages}
						lastSendAttemptAt={lastSendAttemptAt}
						setLastSendAttemptAt={setLastSendAttemptAt}
						isUploadingMedia={isUploadingMedia}
						setUploadingMedia={setUploadingMedia}
						newMessages={newMessages}
						setChosenContact={setChosenContact}
						isTemplatesFailed={isTemplatesFailed}
						isLoadingTemplates={isLoadingTemplates}
						createSavedResponse={createSavedResponse}
						contactProvidersData={contactProvidersData}
						retrieveContactData={resolveContact}
						displayNotification={displayNotification}
						isChatOnly={isChatOnly}
						setChatAssignmentVisible={setChatAssignmentVisible}
						setChatTagsVisible={setChatTagsVisible}
						setSelectionModeEnabled={setSelectionModeEnabled}
						setBulkSendPayload={setBulkSendPayload}
						searchMessagesByKeyword={searchMessagesByKeyword}
						chatId={chatId}
						setChatId={setChatId}
						setOrderBook={setOrderBook}
						setDrawerOpen={setOpen}
						displayCustomError={displayCustomError}
						feeadbackField={feeadbackField}
						setFieldBackField={setFieldBackField}
					/>
				)}
				{isSearchMessagesVisible && (
					<SearchMessage
						initialKeyword={searchMessagesInitialKeyword}
						setInitialKeyword={setSearchMessagesInitialKeyword}
					/>
				)}
				{isContactDetailsVisible && (
					<ContactDetails
						setDrawerOpen={setOpen}
						contactData={chosenContact}
						setContactData={setChosenContact}
						contactProvidersData={contactProvidersData}
						retrieveContactData={resolveContact}
						contactDetails={contactDetails}
						setContactDetails={setContactDetails}
						organizationData={organizationData}
						setOrganizationData={setOrganizationData}
					/>
				)}
				{isChatAssignmentVisible && (
					<ChatAssignment
						waId={waId}
						open={isChatAssignmentVisible}
						setOpen={setChatAssignmentVisible}
					/>
				)}
				{isChatTagsVisible && (
					<ChatTags
						waId={waId}
						open={isChatTagsVisible}
						setOpen={setChatTagsVisible}
						chatId={chatId}
						setChatId={setChatId}
					/>
				)}
				{isChatTagsListVisible && (
					<ChatTagsList waId={waId} open={isChatTagsListVisible} setOpen={setChatTagsListVisible} />
				)}
				{showTagsManagement ? (
					<ManageTags
						waId={waId}
						open={showTagsManagement}
						setOpen={setShowTagsManagement}
						listTags={listTags}
					/>
				) : null}
				{previewMediaObject && <PreviewMedia data={previewMediaObject} />}
				{isDownloadUnsupportedFileVisible && (
					<DownloadUnsupportedFile
						open={isDownloadUnsupportedFileVisible}
						setOpen={setDownloadUnsupportedFileVisible}
						data={unsupportedFile}
					/>
				)}
				<Fade in={progress < 100} timeout={{ exit: 1000 }} unmountOnExit>
					<div className="loadingScreenOuter">
						<LoadingScreen
							progress={progress}
							setProgress={setProgress}
							loadingNow={loadingNow}
							isInitialResourceFailed={isInitialResourceFailed}
						/>
					</div>
				</Fade>

				{isUploadingMedia && isMobileOnly && <UploadMediaIndicator />}
				<BulkSendTemplateDialog
					open={isBulkSendTemplateDialogVisible}
					setOpen={setBulkSendTemplateDialogVisible}
					setBulkSendPayload={setBulkSendPayload}
					setSelectionModeEnabled={setSelectionModeEnabled}
				/>
				<BulkSendTemplateDialog
					open={isBulkSendTemplateWithCallbackDialogVisible}
					setOpen={setBulkSendTemplateWithCallbackDialogVisible}
					setBulkSendPayload={setBulkSendPayload}
					setSelectionModeEnabled={setSelectionModeEnabled}
					sendCallback={() => {
						setUploadRecipientsCSVVisible(true);
					}}
				/>
				<UploadRecipientsCSV
					open={isUploadRecipientsCSVVisible}
					setOpen={setUploadRecipientsCSVVisible}
					addBulkSendRecipients={addBulkSendRecipients}
					bulkSendPayload={bulkSendPayload}
				/>
				<BulkSendTemplateViaCSV
					open={isBulkSendTemplateViaCSVVisible}
					setOpen={setBulkSendTemplateViaCSVVisible}
					finishBulkSendMessage={finishBulkSendMessage}
				/>
				<SendBulkVoiceMessageDialog
					apiService={apiService}
					open={isSendBulkVoiceMessageDialogVisible}
					setOpen={setSendBulkVoiceMessageDialogVisible}
					setUploadingMedia={setUploadingMedia}
					setBulkSendPayload={setBulkSendPayload}
					setSelectionModeEnabled={setSelectionModeEnabled}
				/>
			</>
		);
	};

	useEffect(() => {
		(function () {
			const originalSetItem = localStorage.setItem;
			const originalRemoveItem = localStorage.removeItem;

			localStorage.setItem = function (key, value) {
				const event = new Event('localStorageChange');
				event.key = key;
				event.newValue = value;
				event.oldValue = localStorage.getItem(key);
				originalSetItem.apply(this, arguments);
				window.dispatchEvent(event);
			};

			localStorage.removeItem = function (key) {
				const event = new Event('localStorageChange');
				event.key = key;
				event.newValue = null;
				event.oldValue = localStorage.getItem(key);
				originalRemoveItem.apply(this, arguments);
				window.dispatchEvent(event);
			};
		})();

		window.addEventListener('localStorageChange', (event) => {
			if (event.key === 'os-user') {
				console.log('os-user changed:', event.newValue);
				if (event.newValue && event.newValue != 'null' && event.newValue != 'undefined') {
					setTimeout(() => {
						apiService.updateOneSignalId(
							event.newValue,
							(response: AxiosResponse) => {
								console.log('response', response);
							},
							(error: AxiosError) => {
								console.log('error', error);
							}
						);
					}, 3000);
				}
			}
		});

		initOneSignal();
	}, []);

	const pageRoutes = (path) => {
		if (currentUser?.type) {
			if (isRestaurant) {
				if (path.startsWith(`/restaurants/${id}/orders`)) {
					return <OrderManagement />;
				} else if (path === `/restaurants/${id}/chat/${waId}` && isOrderBook === true) {
					return (
						<OrderBook
							setOrderBook={setOrderBook}
							waId={waId}
							id={id}
							displayCustomError={displayCustomError}
						/>
					);
				} else if (
					path === `/restaurants/${id}/${waId}/editOrder/${orderId}` &&
					editOrderPermission
				) {
					return <EditOrder />;
				} else if (path.startsWith(`/restaurants/${id}/settings`)) {
					return <Settings />;
				}
				// else if (path.startsWith(`/restaurants/${id}/ai-insights`)) {
				// 	return <InsightsAi />;
				// } else if (path.startsWith(`/restaurants/${id}/finance`)) {
				// 	return <Finance />;
				// } else if (path.startsWith(`/marketplace`)) {
				// 	return <MarketPlace />;
				// }
				else if (path.startsWith(`/restaurants/${id}/rewards/dashboard`)) {
					return <RewardsDashboard />;
				} else if (path.includes(`/restaurants/${id}`)) {
					return mainChatComponent();
				} else {
					navigate('/404');
					return;
				}
			} else {
				// if (path === `/dashboard`) {
				// 	return <Dashboard currentUser={currentUser} />;
				// }
				if (path.startsWith(`/suppliers/${id}/catalogs`)) {
					return <Catalogs />;
				} else if (path.startsWith(`/suppliers/${id}/productCatalog`)) {
					return <Products />;
				} else if (path.startsWith(`/suppliers/${id}/orders`)) {
					return <OrderManagement />;
				} else if (
					path === `/suppliers/${id}/${waId}/editOrder/${orderId}` &&
					editOrderPermission
				) {
					return <EditOrder />;
				} else if (path.startsWith(`/suppliers/${id}/settings`)) {
					return <Settings />;
				}
				// else if (path.startsWith(`/suppliers/${id}/ai-insights`)) {
				// 	return <InsightsAi />;
				// }
				// else if (path.startsWith(`/suppliers/${id}/finance`)) {
				// 	return <Finance />;
				// }
				// else if (path.startsWith(`/marketplace/storeFront`)) {
				// 	return <StorefrontPreview />;
				// }
				else if (path.startsWith(`/suppliers/${id}/rewards/dashboard`)) {
					return <RewardsDashboard />;
				} else if (path.startsWith(`/suppliers/${id}/rewards/settings`)) {
					return <RewardsSettings />;
				} else if (path.startsWith(`/suppliers/${id}/rewards/customer-wallet`)) {
					return <CustomerWallet />;
				} else if (path.startsWith(`/suppliers/${id}/customers/list`)) {
					return <CustomerList />;
				} else if (path.startsWith(`/suppliers/${id}/customers/creditLimit`)) {
					return <CreditLimit />;
				} else if (path.includes(`/suppliers/${id}`)) {
					return mainChatComponent();
				} else {
					navigate('/404');
					return;
				}
			}
		} else {
			// if (path.startsWith(`/marketplace/storeFront`)) {
			// 	return <StorefrontPreview />;
			// }
		}
		return;
	};

	useEffect(() => {
		listTags();
	}, [bulkSendPayload]);

	const addBulkSendRecipients = (newWaIds, newTags) => {
		// Combine with selected chats
		if (newWaIds.length > 0) {
			setSelectedChats([...new Set([...newWaIds, ...selectedChats])]);
		}

		if (newTags.length > 0) {
			const preparedNewTags = [];
			newTags.forEach((tagName) => {
				const curTag = findTagByName(tags, tagName);
				if (curTag) {
					preparedNewTags.push(curTag.id);
				}
			});
			setSelectedTags([...new Set([...preparedNewTags, ...selectedTags])]);
		}
	};

	const searchMessagesByKeyword = (_keyword: string) => {
		setSearchMessagesInitialKeyword(_keyword);
		setSearchMessagesVisible(true);
	};

	// useEffect(() => {
	// 	const handleResize = () => {
	// 		setWindowWidth(window.innerWidth);
	// 		if (window.innerWidth >= 750) {
	// 			dispatch(setIsMobileScreen(false));
	// 		} else {
	// 			dispatch(setIsMobileScreen(true));
	// 		}
	// 	};
	// 	window.addEventListener('resize', handleResize);
	// 	return () => {
	// 		window.removeEventListener('resize', handleResize);
	// 	};
	// }, [window.innerWidth]);

	const isShowBottomNav = (path: string) => {
		if (!isMobileWidth || path.includes('/chat') || path?.includes('/editOrder')) {
			return false;
		}
		return true;
	};

	useEffect(() => {
		pageRoutes(location.pathname);
	}, [isOrderBook, location.pathname]);

	const handleRefresh = async () => {
		dispatch(setPullToRefresh(true));

		setTimeout(() => {
			dispatch(setPullToRefresh(false));
		}, [3000]);
	};

	return (
		// <PullToRefresh onRefresh={handleRefresh}>
		<Fade in={checked}>
			<div className={'app__body' + (isIPad13 ? ' absoluteFullscreen' : '')}>
				<ProfileCheckModal orderMetadata={orderMetadata} />

				{showMenu(location.pathname)}
				{isPreviewImages?.length ? <PreviewImage imageUrls={isPreviewImages?.[0]} /> : null}

				<Snackbar
					anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
					open={isSuccessVisible}
					autoHideDuration={6000}
					onClose={handleSuccessClose}
				>
					<Alert onClose={handleSuccessClose} severity="success" elevation={4}>
						{t(successMessage)}
					</Alert>
				</Snackbar>
				<Snackbar
					anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
					open={isErrorVisible}
					autoHideDuration={6000}
					onClose={handleErrorClose}
				>
					<Alert onClose={handleErrorClose} severity="error" elevation={4}>
						{t(errorMessage)}
					</Alert>
				</Snackbar>
				{/* {restaurantApprovalNotification ? (
					<Notifications
						setCloseNotification={setRestaurantApprovalNotification}
						icon={<NotificationIcon />}
						content={
							<div
								style={
									isMobileWidth
										? {
												color: '#000000',
												fontWeight: 500,
												fontSize: '13px',
												letterSpacing: '0.28px',
										  }
										: {
												color: '#000000',
												fontWeight: 500,
												fontSize: '16px',
												letterSpacing: '0.28px',
										  }
								}
							>
								You have pending approvals. Go to the{' '}
								<span
									onClick={() => {
										setRestaurantApprovalNotification(false);
										navigate(`/suppliers/${id}/settings/tallyApproval`);
									}}
									style={{
										color: '#000000',
										fontWeight: 700,
										textDecoration: 'underline',
										cursor: 'pointer',
									}}
								>
									Restaurant Approval list
								</span>{' '}
								to review.
							</div>
						}
					/>
				) : null} */}
				<Snackbar
					open={isOffline}
					autoHideDuration={6000} // Auto-close after 6 seconds
					onClose={handleClose}
					anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
				>
					<Alert severity="warning" variant="filled">
						You are currently offline. Some features may be unavailable.
					</Alert>
				</Snackbar>
				{/* <div className={'app__body' + (isIPad13 ? ' absoluteFullscreen' : '')}> */}
				{pageRoutes(location.pathname)}
				{/* {isShowBottomNav(location.pathname) ? (
					<CustomBottomNavigation setOrderBook={setOrderBook} />
				) : null} */}
			</div>
		</Fade>
		// </PullToRefresh>
	);
}

export default Main;
